import { COUNTRIES } from './countries';
import { Country } from '../../types';

export const MS_PER_DAY = 86400000;
export const MS_PER_HOUR = 3600000;
export const HOURS_PER_DAY = 24;
export * from './countries';
export * from './signup-timezones';
export * from './fixed-offset-zones';
export * from './sanctioned-regions';

export const countriesMapByCountryCodes: Record<string, Country> = {};
for (let i = 0; i < COUNTRIES.length; i++) {
  countriesMapByCountryCodes[COUNTRIES[i].abbr] = COUNTRIES[i];
}

export const countriesMapByCountryName: Record<string, Country> = {};
for (let i = 0; i < COUNTRIES.length; i++) {
  countriesMapByCountryName[COUNTRIES[i].name] = COUNTRIES[i];
}

export const countryCodes = COUNTRIES.map(({abbr}) => abbr);

// The country a device's timezone points to. Most Eastern Caribbean islands also list
// America/Puerto_Rico, which their zones link to, so each country's own zone (zones[0])
// is claimed first: Puerto_Rico means Puerto Rico, not Anguilla.
export const countryCodeByZone: Record<string, string> = {};
for (const { abbr, zones } of COUNTRIES) {
  countryCodeByZone[zones[0]] ??= abbr;
}
for (const { abbr, zones } of COUNTRIES) {
  for (const zone of zones) {
    countryCodeByZone[zone] ??= abbr;
  }
}

export const DEFAULT_PAGE_SIZE = 10;
export const MAX_DISPLAY_PAGES_MOBILE = 3;

export const MS_PER_MIN = 60000;

export const SECONDS_IN_SEVEN_DAYS = 7 * 24 * 3600;

export const TRIAL_LIMIT = 100;
